// removed by extract-text-webpack-plugin
module.exports = {"message_popup":"_1FSBkEUk","message_success":"_1i5h12n1","message_container":"_4EN_QoJI","message_delete":"_1TgjO3KN","buttons_box":"_2uMZGUSZ","missingInfo":"_3y_8--MB","close":"_3kN6RdFN"};


//////////////////
// WEBPACK FOOTER
// ./src/client/website/components/Messages/Messages.styl
// module id = 37
// module chunks = 0